import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const BNK_STMT_getPrefferedOptions_API_CALL = createAsyncThunk(
  'BNK_STMT_getPrefferedOptions_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    const {
      getPrefferedOptionsPayload,
      successFn = () => {},
      errorFn = () => {},
      finallyFn,
    } = payload;
    const { Authorization, customerId, customerRefNum, bankId } =
      getPrefferedOptionsPayload;
    dispatch({
      type: 'BNK_STMT_getPrefferedOptions_API_CALL/pending',
      payload: {},
    });

    SecureClient({
      isEncrypted: true,
      customerId,
      route: 'customerkyc/getprefferedoptionofbank',
      payload: {
        customerRefNum,
        bankId,
      },
      otherPayloadDetailsPresent: true,
      headers: { Authorization },
      method: 'POST',
      successFn: (response) => {
        const bankPrefferedInfo =
          response && response.body && response.body.bankInfoDetails;
        dispatch({
          type: 'BNK_STMT_getPrefferedOptions_API_CALL/fulfilled',
          payload: bankPrefferedInfo,
        });
        if (successFn) successFn(response);
      },
      errorFn: (err) => {
        dispatch({
          type: 'BNK_STMT_getPrefferedOptions_API_CALL/rejected',
          payload: err,
        });
        if (errorFn) errorFn(err);
      },
      finallyFn,
    });
  }
);

export const BNK_STMT_getPrefferedOptions_API_CALL_extrareducer = {
  [BNK_STMT_getPrefferedOptions_API_CALL.pending]: (state, action) => {
    state.getPrefferedOptionsAPICall.isLoading = true;
  },
  [BNK_STMT_getPrefferedOptions_API_CALL.fulfilled]: (state, action) => {
    state.getPrefferedOptionsAPICall.isLoading = false;
    state.getPrefferedOptionsAPICall.isSuccess = true;
    state.getPrefferedOptionsAPICall.isError = false;
    state.getPrefferedOptionsAPICall.response = action.payload;
  },
  [BNK_STMT_getPrefferedOptions_API_CALL.rejected]: (state, action) => {
    state.getPrefferedOptionsAPICall.isLoading = false;
    state.getPrefferedOptionsAPICall.isSuccess = false;
    state.getPrefferedOptionsAPICall.isError = true;
    state.getPrefferedOptionsAPICall.response = action.payload;
  },
};
